import Loadable from "app/components/Loadable";
import { lazy } from "react";

const FeedTypeList = Loadable(lazy(() => import("./FeedTypeList")));
const FeedTypeForm = Loadable(lazy(() => import("./FeedTypeForm")));

const feedTypeRoutes = [
    {
        path: "/FeedType/FeedTypeList",
        element: <FeedTypeList />,
    },
    {
        path: "/FeedType/FeedTypeForm",
        element: <FeedTypeForm />,
    },
    {
        path: "/FeedType/FeedTypeForm/:feedTypeId",
        element: <FeedTypeForm />,
    },
];

export default feedTypeRoutes;
